interface Correspondent {
    id: string
    avatar: string
    name: string
}

export async function fetchUnreadNotificationCount(accessToken: string): Promise<{ unreadCount: number }> {
    return fetch(SiteInfo.starsApiUrl + "/api/content/notification/unreadCount", {
        method: "GET",
        mode: "cors",
        headers: { Authorization: `Bearer ${accessToken}` },
        credentials: "include",
    }).then(async (data: Response) => data.json())
}

export async function fetchChatList(
    accessToken: string,
): Promise<Array<{ chatId: string; correspondent: Correspondent; lastModified: string; newMessageCount: number }>> {
    return fetch(SiteInfo.starsChatListUrl, {
        method: "GET",
        mode: "cors",
        headers: { Authorization: `Bearer ${accessToken}` },
        // credentials: 'include'
    }).then(async (data: Response) => data.json())
}
